module.exports = __webpack_public_path__ + "static/img/B (3).41d6b52b.png";